import { NullableString } from "../Model/NullableString";
import { IImageMap } from "./IImageMap";

// replaces a "./" at the start and removes the file extension at the end
// examples and tests: https://regex101.com/r/4dnEfw/1
const REPLACE_REGEX = /(?:\.\/|[_-\s]+|\..+$)/g;

function normalizeName(name?: string): NullableString {
  if (name == null || typeof name !== `string`) {
    return ``;
  }

  return name.replace(REPLACE_REGEX, ``).toLowerCase();
}

type ImageSelector = (name?: string) => NullableString;

export function importAllImages(r: __WebpackModuleApi.RequireContext): ImageSelector {
  let map: IImageMap = {};
  if (r != null) {
    map = r.keys().reduce(
      (accumulator: IImageMap, imagePath: string) => ({
        ...accumulator,
        [normalizeName(imagePath)]: r(imagePath)
      }),
      {}
    );
  }

  return (name?: string): NullableString => map[normalizeName(name)];
}
